module.exports = __webpack_public_path__ + "static/media/right-chevron.4c4ab4c1.svg";